import styled from "@emotion/styled";
var ButtonWrapper = /*#__PURE__*/ styled("div", {
    target: "eanu830"
})("position:relative;cursor:pointer;");
var StyledButton = /*#__PURE__*/ styled("button", {
    target: "eanu831"
})("display:inline-block;margin:0;padding:0.625rem 1rem;border:1px solid ", function(param) {
    var theme = param.theme;
    return theme.color.natural50;
}, ";border-radius:", function(param) {
    var theme = param.theme;
    return theme.borderRadius.sm;
}, ";width:100%;height:", function(param) {
    var size = param.size;
    return size === "small" ? "2.5rem" : "3.125rem";
}, ";font-size:", function(param) {
    var size = param.size;
    return size === "small" ? "0.75rem" : "1rem";
}, ";line-height:", function(param) {
    var size = param.size;
    return size === "small" ? 1 : 1.5;
}, ";text-transform:capitalize;text-align:left;color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";cursor:pointer;&:hover,&:focus{border-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural40;
}, ";}& + svg{position:absolute;right:1rem;top:", function(param) {
    var size = param.size;
    return size === "small" ? "0.5rem" : "0.75rem";
}, ";width:1.6rem;height:1.6rem;fill:", function(param) {
    var theme = param.theme;
    return theme.color.natural50;
}, ";align-items:center;display:inline-flex;cursor:pointer;pointer-events:none;}");
export { ButtonWrapper, StyledButton };
